import GlobalTable from "@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue";
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import InvoiceOverview from "@/views/probaworkflows_base/invoicing/invoice_overview/InvoiceOverview.vue";
import VerificationOverview from "../verification_managment/verification_overview/VerificationOverview.vue";
import ApplicationContracts from "../application_contracts/ApplicationContracts.vue";

export default {
    name: "ProgressTracker",
    components: {
        NavigationBackButton,
        GlobalTable,
        InvoiceOverview,
        VerificationOverview,
        ApplicationContracts
    },
    data: () => ({
        active_tab: "",
        tabs: [],
        active_document_tabs: "Preview document",
        document_tabs: ['Preview document', 'Signed documents'],
        active_view: "application",
        requests: [
            "please provide correct proof of address",
            "Three months bank statement",
            "Updated tax certificate",
        ],
        dropdown_expanded: false,
        steps: [
            {
                date: "04 Mar",
                title: "In Progress",
                status: "completed",
            },
            {
                date: "05 Mar",
                title: "Submitted",
                status: "completed",
            },
            {
                date: "05 Mar",
                title: "Manual verification",
                status: "in-progress",
                items: [
                    { title: "Menu item 3", status: "completed" },
                    { title: "Menu item 4", status: "in-progress" },
                    { title: "Menu item 5", status: "pending" },
                ],
            },
            {
                date: "06 Mar",
                title: "Auto verification",
                status: "pending",
            },
            {
                date: "06 Mar",
                title: "Compliance",
                status: "pending",
            },
            {
                date: "06 Mar",
                title: "Invoice",
                status: "pending",
            },
            {
                date: "06 Mar",
                title: "Master office",
                status: "pending",
            },
        ],
        founder_name: "",
        form_name: "",
        form_id: "",
        all_application_ids: [],
        current_application_index: -1,
        profile_role_form_id: null,
        profile_role_id: null,
    }),

    created() {
        this.initialize_data_from_route();
    },

    mounted() {
        this.initialize_component();
    },

    methods: {
        parse_route_query_parameters(query) {
            const parsed_data_queries = {
                all_application_ids: JSON.parse(query.all_application_ids || '[]'),
                current_application_index: parseInt(query.current_application_index, 10) || -1,
                profile_role_form_id: query.profile_role_form_id || null,
                profile_role_id: query.profile_role_id || null,
                founder_name: query.founder_name || "",
                form_name: query.form_name || "",
                form_id: query.form_id || ""
            };
            return parsed_data_queries;
        },

        initialize_data_from_route() {
            const parsed_data = this.parse_route_query_parameters(this.$route.query);
            Object.assign(this, parsed_data);

            if (!Array.isArray(this.all_application_ids)) {
                this.all_application_ids = [];
            }
            if (typeof this.current_application_index !== 'number' || isNaN(this.current_application_index)) {
                this.current_application_index = -1;
            }
        },

        initialize_component() {
            if (this.form_name) {
                this.tabs = [this.form_name];
                this.active_tab = this.form_name;
            }
        },

        setactive_view(view) {
            this.active_view = view;
        },

        set_active_tab(tab) {
            this.active_tab = tab;
        },

        set_active_document_tab(document_tab) {
            this.active_document_tabs = document_tab;
        },

        redirect_to_manual_verification() {
            this.$router.push({
                path: "/view_answered_trust_forms",
                query: {
                    profile_role_form_id: this.profile_role_form_id,
                },
            });
        },

        redirect_to_view_requests_information() {
            this.$router.push({
                path: "/view_requests",
                query: {
                    profile_role_form_id: this.profile_role_form_id,
                },
            });
        },

        redirect_to_pending_applications() {
            this.$router.push({
                path: "/pending_applications",
            });
        },

        redirect_to_invoice() {
            this.$router.push({
                path: "/invoice_overview",
            });
        },
    },
};